import { useState } from "react";

import useMedicalCompleteLock from "../../../../../../hooks/useMedicalCompleteLock";
import useRevalidateParent from "../../../../../../hooks/useRevalidateParent";
import useService from "../../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import FormSubmitButton from "../../../../../global/FormComponents/FormSubmitButton";
import ResponseModal from "../../../../../global/ResponseModal";
import { MEDICALLY_COMPLETE_LOCK_MESSAGE } from "../../../../../modules/ClientDetail/Case/utils/constants";

import ApptBillsList from "./ApptBills/ApptBillsList";

export default function DeleteApptProcedure({
  selectedAppt,
  caseInfo,
  selectedBills,
  setSelectedBills,
  setOpenDeleteBills,
}) {
  const revalidateParent = useRevalidateParent("rvClientDetail");
  const administeredServiceRepository = useService("repositories/administered-service-repository");
  const { isAppointmentLocked } = useMedicalCompleteLock();
  const billsLocked = isAppointmentLocked(caseInfo);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenSuccess = () => {
    setOpenSuccess(!openSuccess);
    setOpenDeleteBills(false);
    setSelectedBills([]);
    revalidateParent();
  };

  async function handleDelete() {
    if (billsLocked) {
      setErrorArray([MEDICALLY_COMPLETE_LOCK_MESSAGE]);
      setOpenError(true);
      return;
    }

    setLoading(true);
    try {
      const bills = selectedBills.map((bill) => bill.pk);
      await administeredServiceRepository.deleteBulk(bills);
      setOpenSuccess(!openSuccess);
      setLoading(false);
    } catch (error) {
      const res = error?.response?.data ?? error;
      const errArr = ApiRequestErrorHandler(res);
      setErrorArray(errArr);
      setLoading(false);
      setOpenError(!openError);
    }
  }

  return (
    <div className="w-full justify-center bg-white">
      {!selectedBills ? (
        "Please Select a Administered Service to Continue"
      ) : (
        <>
          <div className="w-1/2 lg:w-[40%]">
            <h2 className="my-4 text-lg font-bold underline">Appointment Info</h2>
            <div className="mb-4 flex w-full text-sm">
              <span className="mr-2 w-1/2 font-bold">Provider Name:</span>
              <span>{selectedAppt.provider.name}</span>
            </div>
            <div className="mb-4 flex w-full text-sm">
              <span className="mr-2 w-1/2 font-bold">Provider Phone:</span>
              <span>{selectedAppt.provider.phone}</span>
            </div>
            <div className="mb-4 flex w-full text-sm">
              <span className="mr-2 w-1/2 font-bold">Date/Time:</span>
              <span> {new Date(selectedAppt.scheduled).toLocaleString()}</span>
            </div>
          </div>

          <div className="mt-8">
            <h2 className="my-4 text-lg font-bold underline">
              Administered services to be deleted
            </h2>
            <div className="relative">
              <ApptBillsList bills={selectedBills} isDeleteMode />
            </div>
          </div>

          {billsLocked && <p className="my-4 text-red-600">{MEDICALLY_COMPLETE_LOCK_MESSAGE}</p>}

          <FormSubmitButton
            isLoading={loading}
            handleSubmit={handleDelete}
            disabled={billsLocked}
            buttonText={
              <h2 className="text-center capitalize">
                Permanently Delete Administered Service
                <span className="lowercase">(s)</span>
              </h2>
            }
            buttonColor="red"
            sx={{
              textTransform: "capitalize",
            }}
          />
        </>
      )}

      <ResponseModal
        title={openSuccess ? "Administered Service(s)" : "Error Deleting Administered Service(s)"}
        description={openSuccess ? "Successfully deleted the Administered Service(s)" : ""}
        openBool={openSuccess || openError}
        errorMessage={openError ? errorArray : ""}
        isError={openError}
        setOpenBool={openSuccess ? setOpenSuccess : setOpenError}
        handleCloseFunc={openSuccess ? handleOpenSuccess : undefined}
      />
    </div>
  );
}
